import { TRPCClientError } from "@trpc/client";

export const isAuthError = (error: unknown): boolean => {
  if (error instanceof TRPCClientError) {
    const code = error.data?.code;
    return code === "UNAUTHORIZED" || code === "FORBIDDEN";
  }
  return false;
};

// Only true for authentication failures (missing/expired/invalid session token),
// NOT for FORBIDDEN, which represents a permission denial on a valid session.
export const isUnauthorizedError = (error: unknown): boolean => {
  if (error instanceof TRPCClientError) {
    return error.data?.code === "UNAUTHORIZED";
  }
  return false;
};
